import { AnalyticsUserPersistenceContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const AnalyticsUserPersistenceProvider = createStaticContextProvider(
  AnalyticsUserPersistenceContext,
  lazyValue(() =>
    import("./analytics-user-persistence").then(
      (module) => module.analyticsUserPersistence,
    ),
  ),
);
